import { getPackageBaseUrl } from 'owa-config';
import { resolve as urlResolve } from 'url';

export const allowedCountriesPhoneInput = [
    'au', // Australia
    'br', // Brazil
    'ca', // Canada
    'co', // Columbia
    'fr', // France
    'gb', // UK
    'in', // India
    'it', // Italy
    'jp', // Japan
    'nl', // Netherlands
    'es', // Spain
    'de', // Germany
    'th', // Thailand
    'ie', // Ireland
    'mx', // Mexico
    'pe', // Peru
    'us', // US
];
export const localizedCountriesPhoneInput = {
    Spain: 'España',
    India: 'भारत',
    Brazil: 'Brasil',
    Italy: 'Italia',
    Japan: '日本',
    Netherlands: 'Nederland',
    Thailand: 'ไทย',
    Peru: 'Perú',
};

export const qrCodeImage = urlResolve(
    getPackageBaseUrl(),
    'resources/img/outlook-mobile-qrcode.png'
);

export const outlookMobileApps = urlResolve(
    getPackageBaseUrl(),
    'resources/img/outlook-mobile-apps.png'
);

export const outlookMobileAppsDarkTheme = urlResolve(
    getPackageBaseUrl(),
    'resources/img/outlook-mobile-apps-dark.png'
);

const reactInputCss = urlResolve(getPackageBaseUrl(), 'resources/css/reactPhoneInput.css');

export function mountReactPhoneInputCss(): HTMLLinkElement {
    let styleElement = document.createElement('link');
    styleElement.rel = 'stylesheet';
    styleElement.href = reactInputCss;
    document.body.appendChild(styleElement);
    return styleElement;
}

export const OutlookClientsToUpdate: string[] = ['OWA'];
